/* eslint-disable */
export default {
  items: [
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003657',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'kllk',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 7,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003656',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'dfgs',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 7,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003655',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'ml,k',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 9,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003654',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'sdx',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 4,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003653',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 's',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 7,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003652',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: ':;k',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 4,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003651',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'gfd',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 4,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003650',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'fgd',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 4,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003649',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'test2',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 9,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
    {
      flowDate: '2017-09-25',
      etmOrderNumber: '0100003648',
      salesOrderNumber: null,
      deliveryNumber: null,
      shipmentNumber: null,
      customerRefNumber: 'yo',
      from: {
        id: '0002000220',
        name: 'Aardappelhandel De Rop N.V.',
      },
      to: {
        id: '0002000221',
        name: 'Aldi Erpe-Mere',
      },
      requestedUnloadingDate: null,
      handshakeStatus: '02',
      handshakeDate: null,
      difference: 'no',
      executeHandshake: false,
      isChecked: null,
      flowLineItems: [
        {
          itemNumber: 100,
          packingId: '000000000021000002',
          palletId: null,
          originalQuantity: 4,
          definitiveQuantity: null,
          differenceQuantity: null,
          contentId: null,
          lineReferenceId: null,
        },
      ],
    },
  ],
  totalItems: 27,
};
